import { MemoryRouter as Router, Routes, Route } from "react-router-dom";
import FileUploads from "../file-uploads/FileUploads";
import QAResultsNew from "../qa-results-new/QAResultsNew";
import Dashboard from "../dashboard/Dashboard";
import { useSession } from "../../context/session-context";
import NotFound from "../../components/common/not-found";
import Forbidden from "../../components/common/forbidden";
import { Loader } from "@bms-ai/bms-ai-ui-lib/components";

const DashboardWrapper = () => {
  const { roleName, hasAccessError } = useSession();

  // Check if there's an access error (e.g., direct URL access without UserId)
  if (hasAccessError) {
    return <NotFound />;
  }

  // Wait until roleName is loaded
  if (!roleName) {
    return <Loader />; // or return a loading spinner
  }

  const isAuthorized =
    roleName === "Admin" ||
    roleName === "Operations" ||
    roleName === "Brief Admin" ||
    roleName === "Marketer";

  if (!isAuthorized) {
    return <Forbidden />;
  }

  return (
    <div className="font-bms">
      <Router initialEntries={["/"]} initialIndex={0}>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/file-uploads" element={<FileUploads />} />
          <Route path="/qa-results" element={<QAResultsNew />} />
          <Route path="/dashboard" element={<Dashboard />} />
        </Routes>
      </Router>
    </div>
  );
};

export default DashboardWrapper;
